import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import axios from "axios";

import { request } from '../../../api';
import cancelPieceForm from '../cancel_piece_form';

const VtrgVideoForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
  blockType
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [whichFormShow, setWhichFormShow] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const blocks = data && data.inner && data.inner.blocks ? data.inner.blocks : [{ type: 'vtrg_inner_block', other: { block_type: 1 } }];
  
  const [values, setValues] = useState({
    vitrage_pieces_vtrg_custom_block: {
      block_type: blockType && blockType,
      vtrg_inner_blocks_attributes:  (blocks && blocks.length > 0) ?
            blocks.map((block, key)=> {
              return ({
                  id: block?.other?.id ? block.other.id : '',
                  bg_color: block?.other?.bg_color ? block.other.bg_color : '', 
                  block_padding: block?.other?.block_padding ? block.other.block_padding : '', 
                  // vtrg_centered_image_attributes: {
                  //   image: '',
                  //   back_color: '',
                  //   id: block.image && block.image.id ? block.image.id : ''
                  // },
                  vtrg_video_attributes:  {
                    first_video: block.video && block.video.first_video ? block.video.first_video : '', 
                    first_video_webm: block.video && block.video.first_video_webm ? block.video.first_video_webm : '', 
                    id: block.video && block.video.id ? block.video.id : '', 
                    autoplay: block.video && block.video.autoplay ? block.video.autoplay : ''
                  },
                  // vtrg_custom_html_attributes: (((whichFormShowInnerFirst === 3) && (key === 0)) || ((whichFormShowInnerSecond === 3) && (key === 1))) ? { 
                  //   body: block.html && block.html.body ? block.html.body : '', 
                  //   id: block.html && block.html.id ? block.html.id : ''
                  // } : {
                  //   body: '',
                  //   id: block.html && block.html.id ? block.html.id : ''
                  // }
              })
            }) : {}
    },
    kind: pieceType, 
    owner_type: instanceType, 
    owner_id: instanceId,  
    id: data && data.id
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }
    
    Object.keys(localData)
      .filter((key) => key in values)
      .forEach((key) => (localData[key] = values[key]));
   
    // TODO снова костыль
    const dataForm = new FormData();
    const appendArray = (form_data, values, name) => {
      if(!values && name)
        form_data.append(name, '');
      else {
        if(typeof values == 'object'){
              for(let key in values) {
                if( (typeof values[key] == 'object') && (key !== ('first_video' || 'first_video_webm')) ) {
                  appendArray(form_data, values[key], name + '[' + key + ']');
                }
                else {
                  form_data.append(name + '[' + key + ']', (typeof values[key] !== 'undefined') ? values[key] : '' );
                }
              }
        }
        else {
          form_data.append(name, values);
        }
      }

      return form_data;
    };
    
    appendArray(dataForm, values.vitrage_pieces_vtrg_custom_block, 'vitrage_pieces_vtrg_custom_block');
    dataForm.append('kind', pieceType);
    dataForm.append('owner_type', instanceType);
    dataForm.append('owner_id', instanceId);
    dataForm.append('id', data && data.id ? data.id : '');

    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : "new"}`,
        dataForm,
        { headers: { 
           'Content-Type': 'multipart/form-data',
           'Access-Control-Allow-Origin': '*' 
        } }
      )
      .then((response) => {
        if (response.statusText === "OK") {
          setSuccessMsg("Изменения успешно внесены");
          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(response?.data?.data?.content ? response.data.data.content : localData);
          }
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg("Произошла ошибка");
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="vitrage_pieces_vtrg_video_form"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : "new"}}`}
        accept-charset="UTF-8"
        data-remote="true"
        method="post"
      >
        <input
          type="hidden"
          name="[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][id]"
          value={values?.vitrage_pieces_vtrg_custom_block?.vtrg_inner_blocks_attributes['0'] && values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].id}
          {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][id]", { value: values?.vitrage_pieces_vtrg_custom_block?.vtrg_inner_blocks_attributes['0']  && values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].id })}
        />
        
        <fieldset className="inputs">
          <label>Видео с формате mp4</label>
          <input
            type="file"
            name={"[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][first_video]"}
            placeholder="Файл"
            {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][first_video]", { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.first_video })}
            onChange={e => {
              setValues(values => {
                values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.first_video  = e.target.files[0];
                return values;
              });
            }}
          />
        </fieldset>
        <fieldset className="inputs">
          <label>Видео в формате webm</label> 
          <input
            type="file"
            name={"[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][first_video_webm]"}
            placeholder="Файл"
            {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][first_video_webm]", { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.first_video_webm })}
            onChange={e => {
              setValues(values => {
                values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.first_video_webm = e.target.files[0];
                return values;
              });
            }}
          />
        </fieldset>
        <fieldset className="inputs">
          <label> Воспроизводить автоматически?</label>
          <input
            type="checkbox"
            name={"[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][autoplay]"}
            placeholder="Файл"
            defaultChecked={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.autoplay }
            {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][vtrg_video_attributes][autoplay]", { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.autoplay })}
            onChange={e => {
              setValues(values => {
                values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].vtrg_video_attributes.autoplay  = e.target.checked;
                return values;
              });
            }}
          />
        </fieldset>

        { (blockType === 2) ? <>
            <fieldset className="inputs">
              <label>Отступы в px</label>
              <input
                  type="text"
                  name="block_padding"
                  defaultValue={blocks[0].other && blocks[0].other.block_padding ? blocks[0].other.block_padding : ''}
                  placeholder="0"
                  {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][block_padding]", { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].block_padding })}
                  
                  onChange={e => {
                    setValues(values => {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].block_padding = e.target.value;
                      return values;
                    });
                  }}
              />
              <p className='inline-hints'>Отступы задаются в порядке: сверху, справа, снизу, слева</p>
            </fieldset>
              

              <fieldset className="inputs">
                <label>Цвет фона</label>
                <input
                    type="color"
                    name="bg_color"
                    defaultValue={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].bg_color}
                    placeholder="например: #FFF"
                    {...register("[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][0][bg_color]", { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].bg_color })}
                    
                    onChange={ (e) => {
                      setValues(values => {
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes['0'].bg_color = e.target.value;
                        return values;
                      });
                    }}
                />
              </fieldset>
            </>
          : ''}
        <input
          type="hidden"
          name="block_type"
          value={blockType}
          {...register('block_type', { value: blockType })}
        />
        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register('kind', { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register('owner_type', { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register('owner_id', { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? 'actions_disable' : 'actions'}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>

      </form>
    </div>
  );
}

export default VtrgVideoForm;